import React from 'react'
import Anchor from './Anchor/Anchor'

import { getAnchors, checkAnchorsBroadcastStatus, checkFanZoneStatus } from './services';

class Anchors extends React.Component {

  intervalId = null;

  state = {
    anchors: null,
    onlineAnchorsIds: [],
    fanZones: []
  };

  componentDidMount() {
    document.title = "Naked News Anchors | Naked News"
    this.getAnchors();
    this.checkStatus();
    this.checkAnchorFanZone();
    this.intervalId = setInterval(this.checkStatus, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  checkAnchorFanZone = async () => {
    const { error, data } = await checkFanZoneStatus();
    if(!error) {
      const fanZoneIDs = data.data.map(fanZone => fanZone.id);

      this.setState({ fanZones: fanZoneIDs });
    }
  }

  getAnchors = async () => {
    const { error, data } = await getAnchors();
    if (!error) {
      this.setState({ anchors: data.data });
    }
  }


  checkStatus = async () => {
    const { error, data } = await checkAnchorsBroadcastStatus();
    if (!error) {
      this.setState({ onlineAnchorsIds: data.data });
    }
  }

  renderAnchors = anchorType => {
    const { anchors, onlineAnchorsIds, fanZones } = this.state;
    const { user } = this.props;
    const isWhitelisted = user ? user.features.includes('ANCHOR_PORTAL') : false;

    // pastAnchor prop is used to temporarily turn off the online indicator for past anchors; remove after broadcast testing on live
    if (anchors[anchorType] && anchors[anchorType].length > 0) {
      return (
        anchors[anchorType].map(anchor => (
          <Anchor 
            key={anchor.id} 
            anchor={anchor}
            pastAnchor={anchorType === 'pastAnchors'}
            fanZones={fanZones}
            isBroadcasting={onlineAnchorsIds.find( ({ id }) => id === anchor.id )}
            isWhitelisted={isWhitelisted} />
        ))
      );
    }
  }

  render() {
    const { anchors } = this.state;
    return anchors && (
      <div className="content soft-white">
        <div className="container">
          <div id="current-anchors">
            <h1 className="h3">Current Anchors</h1>
            <div className="row-r">
              {this.renderAnchors('currentAnchors')}
            </div>
          </div>
          <div id="guest-anchors">
            <h1 className="h3">Guest Anchors</h1>
            <div className="row-r">
              {this.renderAnchors('guestAnchors')}
            </div>
          </div>
          <div id="past-anchors">
            <h1 className="h3">Past Anchors</h1>
            <div className="row-r">
              {this.renderAnchors('pastAnchors')}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Anchors;